// Play icon overlaid on each carousel thumbnail. Ported near-verbatim from
// helix-web's components/global/icons/CustomIcons/videoCarousel/PlayOnPanel.js —
// base fill swapped from helix's navy (#002E66) to birch's --color-navy
// (#0C2848) for brand consistency. Gradient accents left as-is (decorative,
// not tied to a specific token); revisit with design if it looks off.
const PlayOnPanel = () => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      className="cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.8516 0C10.231 0 0 10.231 0 22.8516C0 35.4721 10.231 45.7031 22.8516 45.7031C35.4721 45.7031 45.7031 35.4721 45.7031 22.8516C45.7031 10.231 35.4721 0 22.8516 0Z"
        fill="#0C2848"
      />
      <path
        d="M22.8516 0C10.231 0 0 10.231 0 22.8516C0 35.4721 10.231 45.7031 22.8516 45.7031C35.4721 45.7031 45.7031 35.4721 45.7031 22.8516C45.7031 10.231 35.4721 0 22.8516 0Z"
        fill="url(#paint0_linear_2750_3336)"
      />
      <path
        d="M22.8516 0C10.231 0 0 10.231 0 22.8516C0 35.4721 10.231 45.7031 22.8516 45.7031C35.4721 45.7031 45.7031 35.4721 45.7031 22.8516C45.7031 10.231 35.4721 0 22.8516 0Z"
        fill="url(#paint1_linear_2750_3336)"
      />
      <path
        d="M22.8516 0C10.231 0 0 10.231 0 22.8516C0 35.4721 10.231 45.7031 22.8516 45.7031C35.4721 45.7031 45.7031 35.4721 45.7031 22.8516C45.7031 10.231 35.4721 0 22.8516 0Z"
        fill="url(#paint2_linear_2750_3336)"
      />
      <path
        d="M15.8184 15.5581C15.8187 13.5481 17.9781 12.2776 19.7354 13.2534L32.8672 20.5493C34.6755 21.5539 34.6755 24.1541 32.8672 25.1587L19.7354 32.4546C17.978 33.4304 15.8184 32.1592 15.8184 30.1489V15.5581Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2750_3336"
          x1="45.7031"
          y1="45.7031"
          x2="-7.1648"
          y2="22.5979"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5E6873" />
          <stop offset="1" stopColor="#2E3339" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2750_3336"
          x1="45.7031"
          y1="2.69353e-06"
          x2="-3.7728"
          y2="15.026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A0818C" />
          <stop offset="1" stopColor="#A12C17" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2750_3336"
          x1="6.8103e-07"
          y1="45.7031"
          x2="47.4362"
          y2="16.3307"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EAEAEA" />
          <stop offset="1" stopColor="#A3B8CB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PlayOnPanel;
